<template>
  <div>
    <button-main
      v-if="!props.hideButton"
      variant="primary-bold"
      :size="buttonSize"
      @click="toggleModal"
    >
      <div class="flex items-center justify-center gap-2">
        <svg
          class="text-neutral-subtle-bold"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.75 1.5C14.7657 1.49989 13.7932 1.71508 12.9008 2.13046C12.0084 2.54585 11.2177 3.15139 10.584 3.90464C9.9503 4.65789 9.48903 5.54061 9.23251 6.49094C8.97599 7.44127 8.93042 8.4362 9.099 9.406C9.166 9.796 9.067 10.123 8.878 10.312L2.378 16.811C1.81572 17.3736 1.4999 18.1366 1.5 18.932V21.75C1.5 22.164 1.836 22.5 2.25 22.5H6C6.19891 22.5 6.38968 22.421 6.53033 22.2803C6.67098 22.1397 6.75 21.9489 6.75 21.75V20.25H8.25C8.44891 20.25 8.63968 20.171 8.78033 20.0303C8.92098 19.8897 9 19.6989 9 19.5V18H10.5C10.6988 17.9998 10.8895 17.9207 11.03 17.78L13.688 15.122C13.878 14.933 14.205 14.834 14.594 14.902C15.5149 15.0607 16.4587 15.0264 17.3657 14.8013C18.2727 14.5762 19.123 14.1653 19.8629 13.5945C20.6028 13.0237 21.2161 12.3055 21.6641 11.4854C22.112 10.6653 22.3847 9.76108 22.465 8.83006C22.5453 7.89905 22.4314 6.9615 22.1306 6.07678C21.8297 5.19206 21.3484 4.37945 20.7172 3.6904C20.086 3.00135 19.3185 2.45088 18.4635 2.07383C17.6085 1.69679 16.6845 1.50139 15.75 1.5ZM15.75 4.5C15.5511 4.5 15.3603 4.57902 15.2197 4.71967C15.079 4.86032 15 5.05109 15 5.25C15 5.44891 15.079 5.63968 15.2197 5.78033C15.3603 5.92098 15.5511 6 15.75 6C16.3467 6 16.919 6.23705 17.341 6.65901C17.7629 7.08097 18 7.65326 18 8.25C18 8.44891 18.079 8.63968 18.2197 8.78033C18.3603 8.92098 18.5511 9 18.75 9C18.9489 9 19.1397 8.92098 19.2803 8.78033C19.421 8.63968 19.5 8.44891 19.5 8.25C19.5 7.25544 19.1049 6.30161 18.4017 5.59835C17.6984 4.89509 16.7446 4.5 15.75 4.5Z"
            fill="currentColor"
          />
        </svg>
        <p class="text-neutral-subtle-bold">Confirm Your Ownership</p>
      </div>
    </button-main>

    <ConfirmOwnershipModal
      :visible="state.enableModal"
      :loading="state.loading"
      :enforce-validation="props.enforceValidation"
      @success="handleConfirmOwnership"
      @close="closeModal"
    />

    <loading-idv-modal v-if="state.displayIdvModal" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, watch } from 'vue';
import ButtonMain from '@/components/Button.vue';
import ConfirmOwnershipModal from '@/components/modals/ConfirmOwnershipModal.vue';
import LoadingIdvModal from '@/components/modals/LoadingIDVModal.vue';
import { useOwnership } from '@/composables/useOwnership';
import { useScreenSize } from '@/composables/useScreenSize';

const props = defineProps({
  hideButton: Boolean,
  assignAsControllingManager: Boolean,
  triggerFlow: Boolean,
  enforceValidation: Boolean,
});

const emit = defineEmits(['close', 'execNextStep']);

const {
  state,
  personaEvent,
  toggleModal,
  closeModal,
  handleConfirmOwnership,
  checkUserOwnership,
} = useOwnership(props, emit);

const { screenSize } = useScreenSize();

const buttonSize = computed(() => (screenSize.value === 'desktop' ? '' : 'md'));

watch(
  () => props.triggerFlow,
  (newVal) => {
    if (newVal) toggleModal();
  }
);

watch(personaEvent, async (event) => {
  if (event?.eventName !== 'complete') return;
  if (!state.percentage || !state.jobTitle) return;
  await checkUserOwnership();
});
</script>
